import * as React from 'react';
import * as styles from './DealRentBlock.css';
import { trackDealRentBlockShow } from './tracking';
import { OwnerBadge } from '@cian/owner-badge-component';
import { Sucess16 } from '@cian/ui-kit/icons';

const dealRentIcon = require('./assets/icon.svg');

const advList = [
  'Собственник прошел идентификацию',
  'Первый звонок принимает Циан, а затем арендатор и собственник общаются напрямую',
];

export const DealRentBlock = () => {
  React.useEffect(trackDealRentBlockShow, []);

  return (
    <div className={styles['block']}>
      <div className={styles['badge-wrap']}>
        <OwnerBadge isVerified />
        <img src={dealRentIcon} className={styles['title-icon']} />
        <div className={styles['title']}>Через сервис «Сдай/Сними»</div>
      </div>
      <div>
        {advList.map(adv => (
          <div key={adv} className={styles['list-item']}>
            <div className={styles['list-icon']}>
              <Sucess16 color="primary_100" />
            </div>
            {adv}
          </div>
        ))}
      </div>
    </div>
  );
};
